import React, { useEffect, useState, useRef } from "react";
import Slider from "../../../components/slider";
import ProductItem from "./productItem";
import { connect } from "react-redux";
import Button from "../../../components/common/button";
import { PRODUCT_TYPE, IProduct } from "../../../interfaces/products";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { History } from "history";
import { routes } from "../../routes";
import { ShoppingCart, Loader, ChevronLeft, ChevronRight } from "react-feather";
import { IApplicationState } from "../../../redux/reducers";
import productService from "../../../services/productService";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { PaginateSlider } from "../../../components/slider/paginateSlider";
import { IUser } from "../../../interfaces/user";
import Upgrade from "../../../components/common/upgrade";
import { IBrand } from "../../../interfaces/company";
import { IPaginateList } from "../../../interfaces/pagination";
import Pagination from "../../../components/pagination";
import { Dispatch } from "redux";
import { paginateAction } from "../../../redux/actions/pagination/pagination";
import { product } from "../../../redux/actions/actionContants";

interface IProps extends RouteComponentProps {
	history: History;
	active: IPaginateList<IProduct[]> & { cache: { [page: number]: IProduct[] } };
	getActiveProducts: () => Promise<any>;
	removeProduct: (productId: string) => Promise<any>;
	paginate: (page: number) => void;
	selected_brand: IBrand;
	profile?: IUser | undefined;
}

const ActiveProduct: React.FC<IProps> = ({
	history,
	getActiveProducts,
	active,
	removeProduct,
	...props
}) => {
	const [loading, setLoading] = useState<boolean>(false);
	const [removing, setRemoving] = useState<boolean>(false);
	const scrollContainerRef = useRef<HTMLDivElement>(null);
	const abortControllerRef = useRef<AbortController | null>(null);

	useEffect(() => {
		// Cancel any pending request
		if (abortControllerRef.current) {
			abortControllerRef.current.abort();
		}

		// Create new abort controller for this request
		abortControllerRef.current = new AbortController();

		setLoading(true);

		const currentPage = active.pagination.page;
		if (active.cache && active.cache[currentPage]) {
			setLoading(false);
			return;
		}

		getActiveProducts()
			.finally(() => {
				setLoading(false);
				abortControllerRef.current = null;
			});

		// Cleanup function to abort request if component unmounts or dependencies change
		return () => {
			if (abortControllerRef.current) {
				abortControllerRef.current.abort();
			}
		};
	}, [props.selected_brand, active.pagination.page]);


	function onRemoveHandler(productId: string) {
		setRemoving(true);

		confirmAlert({
			title: "Remove Product",
			message: "Are you sure you want to remove this product?",
			buttons: [
				{
					label: "Remove",
					onClick: () => {
						removeProduct(productId).finally(() => {
							setLoading(true);
							getActiveProducts().finally(() => {
								setLoading(false);
							});
						});
					}
				},
				{
					label: "Cancel",
					onClick: () => { }
				}
			]
		});
	}

	const scrollLeft = () => {
		if (scrollContainerRef.current) {
			scrollContainerRef.current.scrollBy({
				left: -300,
				behavior: 'smooth'
			});
		}
	};

	const scrollRight = () => {
		if (scrollContainerRef.current) {
			scrollContainerRef.current.scrollBy({
				left: 300,
				behavior: 'smooth'
			});
		}
	};

	// return null;
	return (
		<div className="active-product">
			<span className="title">
				<h4 className="mr-2 font-weight-semibold">Active Products</h4>
				{loading ? (
					<Loader className="fa-spin mr-2" />
				) : (
					<h4 className="color-bg-blue mr-3 font-weight-normal">{active.pagination.total}</h4>
				)}
				<Button color="primary" className="btn-round">
					<ShoppingCart className="mr-2" size={18} />
					Retail
				</Button>
			</span>
			{props.profile?.company?.subscription_type == "supplier" ? (
				<Upgrade />
			) : (
				<div className="active-products-container">
					<button
						className="active-scroll-btn active-scroll-left"
						onClick={scrollLeft}
						disabled={loading || active.list.length === 0}
					>
						<ChevronLeft size={20} />
					</button>
					<div
						className="active-products-list"
						ref={scrollContainerRef}
					>
						{active.list.map((product) => (
							<div key={product.id} className="active-product-item">
								<ProductItem
									product={product}
									productType={PRODUCT_TYPE.ACTIVE}
									onRemoveHandler={onRemoveHandler}
								/>
							</div>
						))}
					</div>
					<button
						className="active-scroll-btn active-scroll-right"
						onClick={scrollRight}
						disabled={loading || active.list.length === 0}
					>
						<ChevronRight size={20} />
					</button>
				</div>
			)}
			{props.profile?.company?.subscription_type == "supplier" ? (
				<></>
			) : (
				<div className="pagination-wrapper pagination-right pagination-small">
					<Pagination
						className="pagination-right pagination-small"
						page={active.pagination.page}
						total={active.pagination.total}
						paginatorSize="md"
						pages={active.pagination.pages}
						size={active.pagination.size}
						handlePageChange={props.paginate}
						loading={loading}
					/>
				</div>
			)}
		</div>
	);
};

const mapStateToProps = (state: IApplicationState) => ({
	active: state.product.active,
	profile: state.user.profile,
	selected_brand: state.user.selected_brand
});

const mapDispatchToProps = {
	getActiveProducts: () => productService.getActiveProducts(),
	removeProduct: (productId: string) => productService.removeProduct(productId),
	paginate: (page: number) => (dispatch: Dispatch) => {
		dispatch(paginateAction(product.PAGINATE_ACTIVE_PRODUCT, page));
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ActiveProduct));
